define('shared/initializer/form/adapters/mixins/fields/Country',[
    '$',
    'shared/page/market',
    'shared/lib/RSVP',
    'shared/util/fields/common'
], function(
    $,
    getMarket,
    RSVP,
    fieldsUtil
){
    'use strict';

    function Ctor(){}

    var p = Ctor.prototype;

    p.doBeforeSubmit = function(){
        var me = this;
        var countryField = me.items.get('country');

        if(countryField && countryField.$el) {
            return getMarket()
                .then(function(pageMarketCode){
                    var selectedMarketCode = countryField.$el.val();
                    fieldsUtil.setFieldValueIfExists(selectedMarketCode, 'local', me.$form);
                    fieldsUtil.appendFieldValueIfExists(';pageMarketCode=' + pageMarketCode, 'Description', me.$form);
                });
        }else{
            return RSVP.resolve();
        }
    };

    return Ctor;
});

